import CheckCircleSharpIcon from '@mui/icons-material/CheckCircleSharp';
import { Divider } from '@mui/material';
import { useSearchAiPluginStore } from 'store/searchAiPluginStore';
import { CustomColor } from './CustomColor';
import CustomColorPicker from './CustomColorPicker';

const AiSearchContent = () => {
    const { customization, setCustomization } = useSearchAiPluginStore();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setCustomization('searchButtonText', e.target.value);

    return (
        <main className="w-full px-10 py-6">
            <h1 className="text-xl font-bold text-gray-800 mb-2">Design Your Brand Style</h1>
            <p className="text-gray-600 mb-8">
                Elevate your brand's voice, craft a distinctive conversational style, and unleash AI-powered search on your website.
            </p>
            <div className="my-10"></div>
            <Divider />

            <div className="my-8">
                <h2 className="text-lg font-bold text-gray-800 mb-2">Search field text</h2>
                <p className="text-gray-600 mb-3">Write engaging messages to your clients to encourage them to search.</p>
                <input
                    type="text"
                    placeholder="Describe your dream property here...."
                    className="w-1/2 px-4 py-3.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={customization.searchButtonText}
                    onChange={handleChange}
                />
            </div>

            <div className="mb-8">
                <h2 className="text-lg font-bold text-gray-800 mb-2">Color</h2>
                <p className="text-gray-600 mb-4">Select the color that reflects your brand.</p>
                <CustomColorPicker colorField="searchButtonColor" />

                <CustomColor colorField="searchButtonColor" />

                <div className="my-10"></div>
                <Divider />
                <div className="my-8">
                    <h2 className="text-lg font-bold text-gray-800 mb-2">Theme</h2>
                    <p className="text-gray-600 mb-3">Select how your AI search will look and feel.</p>
                    <SearchSection isSmall isSelected={customization.buttonSize === 'small'} onClick={() => setCustomization('buttonSize', 'small')} />
                    <div className="mt-10">
                        <SearchSection isSelected={customization.buttonSize === 'medium'} onClick={() => setCustomization('buttonSize', 'medium')} />
                    </div>
                    <div className="mt-10">
                        <SearchSection isBig isSelected={customization.buttonSize === 'big'} onClick={() => setCustomization('buttonSize', 'big')} />
                    </div>
                </div>
            </div>
        </main>
    );
};

export default AiSearchContent;

const SearchSection = ({
    isSmall = false,
    isBig = false,
    isSelected,
    onClick,
}: {
    isSmall?: boolean;
    isBig?: boolean;
    isSelected: boolean;
    onClick: () => void;
}) => {
    const { customization } = useSearchAiPluginStore();

    return (
        <div className={`${isSelected ? 'border-2 border-black' : ''} rounded-lg p-8 cursor-pointer w-3/4 bg-gray-50 relative`} onClick={onClick}>
            {isSelected && (
                <div className="absolute -right-2.5 -top-2.5 bg-white rounded-full">
                    <CheckCircleSharpIcon className="text-black" />
                </div>
            )}
            {!isBig && (
                <div className={`border rounded-lg p-4}`}>
                    <div className={`w-full h-12 bg-white rounded-lg ${isSmall ? 'relative' : ''}`}>
                        {isSmall && <div className="absolute right-2 top-1.5 w-20 h-8 rounded" style={{ backgroundColor: customization.searchButtonColor }} />}
                    </div>
                </div>
            )}
            {isBig && (
                <div className={`border rounded-lg bg-white p-6}`}>
                    <div className={`w-full h-11 rounded-lg`}></div>
                    <div className="p-3.5">
                        <button className="w-full h-12 rounded-lg" style={{ backgroundColor: customization.searchButtonColor }}></button>
                    </div>
                </div>
            )}

            {!isSmall && !isBig && <div className="my-2 h-11 rounded" style={{ backgroundColor: customization.searchButtonColor }} />}
            <h1 className="text-right text-sm text-gray-600 mt-3">
                <div className="flex items-center justify-end gap-1">
                    POWERED BY
                    <span className="font-bold">hello:data</span>
                    <img src="/image/Logo_65_80.png" className="w-5 h-5" />
                </div>
            </h1>
            <h3 className="text-sm font-semibold mt-3">{isSmall ? 'Small button' : 'Big button'}</h3>
        </div>
    );
};
